export default {
    common: {
        title: 'Rediger bilde',
        cancel: 'Avbryt',
        save: 'Lagre',
        crop: 'Avling',
        adjustments: 'Justeringer',
        filters: 'Filtre',
        frames: 'Rammer',
        overlays: 'Overleggelser',
        text: 'Tekst',
        stickers: 'Klistremerker',
        brush: 'Børste',
        ai: 'Lag et bilde ved hjelp av kunstig intelligens',
        reset: 'Nullstill',
        comingSoon: 'Kommer snart...',
        apply: 'Søk',
        undo: 'Angre',
        redo: 'Gjør om',
        flipHorizontal: 'Speil horisontalt',
        flipVertical: 'Vend vertikalt',
        rotateClockwise: 'Roter med klokken',
        rotateAntiClockwise: 'Roter med urviseren',
        warning: 'Advarsel',
        discard: 'kaste',
        continue: 'Fortsett redigering',
        discardHeading: 'Forkast endringene dine?',
        discardSubHeading: 'Hvis du lukker bildebehandleren, vil endringene dine ikke bli lagret',
        subtitle: 'De støttede bildeformatene er PNG og JPEG',
        clone: 'Klon',
        delete: 'Slett',
    },
};
